import { Smartphone } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const TryAppButton = () => {
  const { tr } = useLang();
  return (
    <a data-testid="try-app-btn" href="https://www.demapp.shop" target="_blank" rel="noopener noreferrer"
      className="w-full h-10 px-4 text-sm font-medium inline-flex items-center justify-center gap-1.5 bg-[#E0262C] text-white hover:bg-[#2B3036] transition-colors">
      <Smartphone className="w-4 h-4" /> {tr("Provala ora", "Try it now")}
    </a>
  );
};
